import React from 'react';
import { Link } from "react-router-dom";

function Layout({ mainhero, children, fullHeight }) {
  let clName = mainhero ? 'hero' : '';
  clName = `${clName} ${ fullHeight ? 'is-fullheight' : '' }`;
  return (
    <>
        <div className={`${clName} is-default is-bold`}>
            <nav className="navbar navbar-wrapper is-cloned">
                <div className="container">
                    <div className="navbar-brand">
                        <a className="navbar-item" href="/">
                            <img src="/assets/images/logos/butun_logo.png" alt="" />
                        </a>

                        <div className="custom-burger" data-target="is-cloned">
                            <a className="responsive-btn" href="javascript:void(0);">
                                <span className="menu-toggle">
                                    <span className="icon-box-toggle">
                                        <span className="rotate">
                                            <i className="icon-line-top"></i>
                                            <i className="icon-line-center"></i>
                                            <i className="icon-line-bottom"></i>
                                        </span>
                                    </span>
                                </span>
                            </a>
                        </div>
                    </div>

                    <div id="is-cloned" className="navbar-menu">
                        <div className="navbar-end">
                            <a className="navbar-item is-slide is-centered-tablet" href="#test">
                                Çözümlerimiz
                            </a>
                            <div className="navbar-item is-button is-centered-tablet">
                                <a href="#contact" className="button button-cta is-bold btn-align secondary-btn raised">
                                    Bize Ulaşın
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
            </nav>

            <nav className="navbar navbar-wrapper is-transparent is-static">
                <div className="container">
                    <div className="navbar-brand">
                        <a className="navbar-item" href="/">
                            <img src="/assets/images/logos/butun_logo.png" alt="" />
                        </a>
                        <div className="custom-burger" data-target="is-static">
                            <a className="responsive-btn" href="javascript:void(0);">
                                <span className="menu-toggle">
                                    <span className="icon-box-toggle">
                                        <span className="rotate">
                                            <i className="icon-line-top"></i>
                                            <i className="icon-line-center"></i>
                                            <i className="icon-line-bottom"></i>
                                        </span>
                                    </span>
                                </span>
                            </a>
                        </div>
                    </div>

                    <div id="is-static" className="navbar-menu">
                        <div className="navbar-end">
                            <a className="navbar-item is-slide is-centered-tablet" href="#test">
                                Çözümlerimiz
                            </a>
                            <div className="navbar-item is-button is-centered-tablet">
                                <a href="#contact" className="button button-cta is-bold btn-align secondary-btn raised">
                                    Bize Ulaşın
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
            </nav>
            {mainhero}
        </div>
        {children}
        <footer className="footer footer-light-medium" id="contact">
            <div className="container">
                <div className="columns">
                    <div className="column is-4">
                        <div className="pt-10 pb-10">
                            <img className="small-footer-logo" src="/assets/images/logos/butun_logo.png" alt="" />
                            <div className="footer-description pt-10 pb-10">
                                Kurumsal sistem tasarımı ve uyarlamasında kalite, hız ve üstün hizmet vaad ediyoruz.
                            </div>
                        </div>
                        <div>
                            <span className="moto">Bize takip edin.</span>
                            <div className="social-links pt-10 pb-10">
                                <a href="https://www.facebook.com/Butunbi-103898267660418" target="_blank">
                                    <span className="icon"><i className="fa fa-facebook"></i></span>
                                </a>
                                <a href="https://twitter.com/butunbi" target="_blank">
                                    <span className="icon"><i className="fa fa-twitter"></i></span>
                                </a>
                                <a href="https://www.linkedin.com/company/b%C3%BCt%C3%BCnbi" target="_blank">
                                    <span className="icon"><i className="fa fa-linkedin"></i></span>
                                </a>
                                <a href="https://instagram.com/butunbi" target="_blank">
                                    <span className="icon"><i className="fa fa-instagram"></i></span>
                                </a>
                                <a href="https://www.youtube.com/channel/UCVN49H8IKifN1mJD3J4nvng" target="_blank">
                                    <span className="icon"><i className="fa fa-youtube"></i></span>
                                </a>
                            </div>
                        </div>
                    </div>
                    <div className="column is-6 is-offset-2">
                        <div className="columns">
                            <div className="column">
                                <ul className="footer-column">
                                    <li className="column-header">
                                        BUTUN BILGI ISLEM DANISMANLIK YAZILIM HIZMETLERI TIC. LTD. STI.
                                    </li>
                                    <li className="column-item">Adres</li>
                                    <li className="column-item">1373 sok. No:8 D:601</li>
                                    <li className="column-item">Konak</li>
                                    <li className="column-item">İzmir</li>
                                    <li className="column-item"><a href="mailto:info@butun-yd.com">info@butun-yd.com</a></li>
                                </ul>
                            </div>

                        </div>
                    </div>
                </div>
            </div>
        </footer>
        <div className="side-navigation-menu">
            <div className="category-menu-wrapper">
                <ul className="categories">
                    <li className="square-logo"><img src="/assets/images/logos/square-white.svg" alt="" /></li>
                    <li className="category-link is-active" data-navigation-menu="demo-pages"><i className="sl sl-icon-layers"></i></li>
                    <li className="category-link" data-navigation-menu="onepagers"><i className="sl sl-icon-energy"></i></li>
                    <li className="category-link" data-navigation-menu="components"><i className="sl sl-icon-grid"></i></li>
                    <li className="category-link" data-navigation-menu="extras"><i className="sl sl-icon-present"></i></li>
                </ul>

                <ul className="author">
                    <li>
                        <a href="https://cssninja.io" target="_blank">
                            <img className="main-menu-author" src="/assets/images/logos/cssninja.svg" alt="" />
                        </a>
                    </li>
                </ul>
            </div>

            <div id="demo-pages" className="navigation-menu-wrapper animated preFadeInRight fadeInRight">
                <div className="navigation-menu-header">
                    <span>Demo pages</span>
                    <a className="ml-auto hamburger-btn navigation-close" href="javascript:void(0);">
                        <span className="menu-toggle">
                            <span className="icon-box-toggle">
                                <span className="rotate">
                                    <i className="icon-line-top"></i>
                                    <i className="icon-line-center"></i>
                                    <i className="icon-line-bottom"></i>
                                </span>
                            </span>
                        </span>
                    </a>
                </div>
                <ul className="navigation-menu">
                    <li className="has-children"><a className="parent-link" href="#"><span className="material-icons">weekend</span>Agency kit</a>
                        <ul>
                            <li><a className="is-submenu" href="/agency/index.html">Homepage</a></li>
                            <li><a className="is-submenu" href="/agency/agency-about.html">About</a></li>
                            <li><a className="is-submenu" href="/agency/agency-portfolio.html">Portfolio</a></li>
                            <li><a className="is-submenu" href="/agency/agency-contact.html">Contact</a></li>
                            <li><a className="is-submenu" href="/agency/agency-blog.html">Blog</a></li>
                            <li><a className="is-submenu" href="/agency/agency-post-sidebar.html">Post sidebar</a></li>
                            <li><a className="is-submenu" href="/agency/agency-post-nosidebar.html">Post no sidebar</a></li>
                        </ul>
                    </li>
                    <li className="has-children"><a className="parent-link" href="#"><span className="material-icons">wb_incandescent</span>Startup
                            kit</a>
                        <ul>
                            <li><a className="is-submenu" href="/startup/index.html">Homepage</a></li>
                            <li><a className="is-submenu" href="/startup/startup-about.html">About</a></li>
                            <li><a className="is-submenu" href="/startup/startup-product.html">Product</a></li>
                            <li><a className="is-submenu" href="/startup/startup-contact.html">Contact</a></li>
                            <li><a className="is-submenu" href="/startup/startup-login.html">Login</a></li>
                            <li><a className="is-submenu" href="/startup/startup-signup.html">Sign up</a></li>
                        </ul>
                    </li>
                    <li className="has-children"><a className="parent-link" href="#"><span className="material-icons">looks</span>Landing kit
                            v1</a>
                        <ul>
                            <li><a className="is-submenu" href="/landing-kits/kit-1/index.html">Landing page</a></li>
                            <li><a className="is-submenu" href="/landing-kits/kit-1/landing-features.html">Feature page</a></li>
                            <li><a className="is-submenu" href="/landing-kits/kit-1/landing-pricing.html">Pricing page</a></li>
                            <li><a className="is-submenu" href="/landing-kits/kit-1/landing-login.html">Login page</a></li>
                            <li><a className="is-submenu" href="/landing-kits/kit-1/landing-signup.html">Signup page</a></li>
                        </ul>
                    </li>
                    <li className="has-children"><a className="parent-link" href="#"><span className="material-icons">invert_colors</span>Landing
                            kit v2</a>
                        <ul>
                            <li><a className="is-submenu" href="/landing-kits/kit-2/index.html">Landing page</a></li>
                            <li><a className="is-submenu" href="/landing-kits/kit-2/landing-v1-features.html">Feature page</a></li>
                            <li><a className="is-submenu" href="/landing-kits/kit-2/landing-v1-pricing.html">Pricing page</a></li>
                            <li><a className="is-submenu" href="/landing-kits/kit-2/landing-v1-login.html">Login page</a></li>
                            <li><a className="is-submenu" href="/landing-kits/kit-2/landing-v1-signup.html">Signup page</a></li>
                        </ul>
                    </li>
                    <li className="has-children"><a className="parent-link" href="#"><span className="material-icons">chat_bubble</span>Landing
                            kit v3</a>
                        <ul>
                            <li><a className="is-submenu" href="/landing-kits/kit-3/index.html">Landing page</a></li>
                            <li><a className="is-submenu" href="/landing-kits/kit-3/landing-v2-features.html">Feature page</a></li>
                            <li><a className="is-submenu" href="/landing-kits/kit-3/landing-v2-pricing.html">Pricing page</a></li>
                            <li><a className="is-submenu" href="/landing-kits/kit-3/landing-v2-login.html">Login page</a></li>
                            <li><a className="is-submenu" href="/landing-kits/kit-3/landing-v2-signup.html">Signup page</a></li>
                        </ul>
                    </li>
                    <li className="has-children"><a className="parent-link" href="#"><span className="material-icons">business</span>Landing
                            kit v4</a>
                        <ul>
                            <li><a className="is-submenu" href="/landing-kits/kit-4/index.html">Landing page</a></li>
                            <li><a className="is-submenu" href="/landing-kits/kit-4/landing-v3-pricing.html">Pricing page</a></li>
                            <li><a className="is-submenu" href="/landing-kits/kit-4/landing-v3-help.html">Help center</a></li>
                            <li><a className="is-submenu" href="/landing-kits/kit-4/landing-v3-help-category.html">Help category</a></li>
                            <li><a className="is-submenu" href="/landing-kits/kit-4/landing-v3-help-article.html">Help article</a></li>
                            <li><a className="is-submenu" href="/landing-kits/kit-4/landing-v3-signup.html">Login</a></li>
                            <li><a className="is-submenu" href="/landing-kits/kit-4/landing-v3-login.html">Sign up</a></li>
                        </ul>
                    </li>
                    <li className="has-children"><a className="parent-link" href="#"><span className="material-icons">face</span>Landing kit v5</a>
                        <ul>
                            <li><a className="is-submenu has-new-feature" href="/landing-kits/kit-5/index.html">Landing page</a></li>
                            <li><a className="is-submenu has-new-feature" href="/landing-kits/kit-5/landing-v4-features.html">Feature
                                    page</a></li>
                            <li><a className="is-submenu has-new-feature" href="/landing-kits/kit-5/landing-v4-pricing.html">Pricing
                                    Page</a></li>
                            <li><a className="is-submenu has-new-feature" href="/landing-kits/kit-5/landing-v4-login.html">Login /
                                    Signup</a></li>
                        </ul>
                    </li>
                    <li className="has-children"><a className="parent-link" href="#"><span className="material-icons">cloud</span>Landing kit
                            v6</a>
                        <ul>
                            <li><a className="is-submenu has-new-update" href="/landing-kits/kit-6/index.html">Landing page</a></li>
                            <li><a className="is-submenu has-new-update" href="/landing-kits/kit-6/landing-v5-home.html">Landing page
                                    v2</a></li>
                            <li><a className="is-submenu has-new-update" href="/landing-kits/kit-6/landing-v5-login.html">Login page</a></li>
                            <li><a className="is-submenu has-new-update" href="/landing-kits/kit-6/landing-v5-signup.html">Signup page</a></li>
                        </ul>
                    </li>
                </ul>
            </div>
            <div id="onepagers" className="navigation-menu-wrapper animated preFadeInRight fadeInRight is-hidden">
                <div className="navigation-menu-header">
                    <span>One Pagers</span>
                    <a className="ml-auto hamburger-btn navigation-close" href="javascript:void(0);">
                        <span className="menu-toggle">
                            <span className="icon-box-toggle">
                                <span className="rotate">
                                    <i className="icon-line-top"></i>
                                    <i className="icon-line-center"></i>
                                    <i className="icon-line-bottom"></i>
                                </span>
                            </span>
                        </span>
                    </a>
                </div>
                <ul className="navigation-menu">
                    <li className="has-children"><a className="parent-link has-new" href="#"><span className="material-icons">dashboard</span>One Pager 1</a>
                        <ul>
                            <li><a className="is-submenu has-new-update is-2_3" href="/one-pager-1/">Header 1</a></li>
                            <li><a className="is-submenu has-new-update is-2_3" href="/one-pager-1/op1-2.html">Header 2</a></li>
                            <li><a className="is-submenu has-new-update is-2_3" href="/one-pager-1/op1-3.html">Header 3</a></li>
                            <li><a className="is-submenu has-new-update is-2_3" href="/one-pager-1/op1-4.html">Header 4</a></li>
                        </ul>
                    </li>
                </ul>
            </div>
            <div id="components" className="navigation-menu-wrapper animated preFadeInRight fadeInRight is-hidden">
                <div className="navigation-menu-header">
                    <span>Components</span>
                    <a className="ml-auto hamburger-btn navigation-close" href="javascript:void(0);">
                        <span className="menu-toggle">
                            <span className="icon-box-toggle">
                                <span className="rotate">
                                    <i className="icon-line-top"></i>
                                    <i className="icon-line-center"></i>
                                    <i className="icon-line-bottom"></i>
                                </span>
                            </span>
                        </span>
                    </a>
                </div>
                <ul className="navigation-menu">
                    <li className="has-children"><a className="parent-link" href="#"><span className="material-icons">view_quilt</span>Layout</a>
                        <ul>
                            <li><a className="is-submenu has-new-feature" href="/_components-layout-grid.html">Grid system</a></li>
                            <li><a className="is-submenu" href="/_components-layout-video.html">Video background</a></li>
                            <li><a className="is-submenu" href="/_components-layout-parallax.html">Parallax</a></li>
                            <li><a className="is-submenu" href="/_components-layout-headers.html">Headers</a></li>
                            <li><a className="is-submenu" href="/_components-layout-footers.html">Footers</a></li>
                            <li><a className="is-submenu has-new-feature" href="/_components-layout-typography.html">Typography</a></li>
                            <li><a className="is-submenu" href="/_components-layout-colors.html">Colors</a></li>
                        </ul>
                    </li>
                    <li className="has-children"><a className="parent-link" href="#"><span className="material-icons">subject</span>Navbars</a>
                        <ul>
                            <li><a className="is-submenu has-new-feature" href="/_components-layout-navbar-fade-light.html">Fade light</a></li>
                            <li><a className="is-submenu has-new-feature" href="/_components-layout-navbar-fade-dark.html">Fade dark</a></li>
                            <li><a className="is-submenu has-new-feature" href="/_components-layout-navbar-static-light.html">Static
                                    light</a></li>
                            <li><a className="is-submenu has-new-feature" href="/_components-layout-navbar-static-dark.html">Static
                                    dark</a></li>
                            <li><a className="is-submenu has-new-feature" href="/_components-layout-navbar-static-solid.html">Static
                                    solid</a></li>
                            <li><a className="is-submenu has-new-feature" href="/_components-layout-navbar-double-dark.html">Double
                                    dark</a></li>
                            <li><a className="is-submenu has-new-feature" href="/_components-layout-navbar-double-light.html">Double
                                    light</a></li>
                        </ul>
                    </li>
                    <li className="has-children"><a className="parent-link" href="#"><span className="material-icons">view_stream</span>Sections</a>
                        <ul>
                            <li><a className="is-submenu" href="/_components-sections-features.html">Features</a></li>
                            <li><a className="is-submenu" href="/_components-sections-pricing.html">Pricing</a></li>
                            <li><a className="is-submenu" href="/_components-sections-team.html">Team</a></li>
                            <li><a className="is-submenu" href="/_components-sections-testimonials.html">Testimonials</a></li>
                            <li><a className="is-submenu" href="/_components-sections-clients.html">Clients</a></li>
                            <li><a className="is-submenu" href="/_components-sections-counters.html">Counters</a></li>
                            <li><a className="is-submenu" href="/_components-sections-carousel.html">Carousel</a></li>
                        </ul>
                    </li>
                    <li className="has-children"><a className="parent-link" href="#"><span className="material-icons">playlist_add_check</span>Basic
                            UI</a>
                        <ul>
                            <li><a className="is-submenu" href="/_components-basicui-cards.html">Cards</a></li>
                            <li><a className="is-submenu" href="/_components-basicui-buttons.html">Buttons</a></li>
                            <li><a className="is-submenu" href="/_components-basicui-dropdowns.html">Dropdowns</a></li>
                            <li><a className="is-submenu" href="/_components-basicui-lists.html">Lists</a></li>
                            <li><a className="is-submenu" href="/_components-basicui-modals.html">Modals</a></li>
                            <li><a className="is-submenu" href="/_components-basicui-tabs.html">Tabs & pills</a></li>
                            <li><a className="is-submenu" href="/_components-basicui-accordion.html">Accordions</a></li>
                            <li><a className="is-submenu" href="/_components-basicui-badges.html">Badges & labels</a></li>
                            <li><a className="is-submenu" href="/_components-basicui-popups.html">Popups</a></li>
                        </ul>
                    </li>
                    <li className="has-children"><a className="parent-link" href="#"><span className="material-icons">playlist_add</span>Advanced
                            UI</a>
                        <ul>
                            <li><a className="is-submenu" href="/_components-advancedui-tables.html">Tables</a></li>
                            <li><a className="is-submenu" href="/_components-advancedui-timeline.html">Timeline</a></li>
                            <li><a className="is-submenu" href="/_components-advancedui-boxes.html">Boxes</a></li>
                            <li><a className="is-submenu" href="/_components-advancedui-messages.html">Messages</a></li>
                            <li><a className="is-submenu has-new-feature" href="/_components-advancedui-megamenu.html">Megamenu</a></li>
                            <li><a className="is-submenu has-new-feature" href="/_components-advancedui-calendar.html">Calendar</a></li>
                        </ul>
                    </li>
                    <li className="has-children"><a className="parent-link has-new" href="#"><span className="material-icons">check_box</span>Forms</a>
                        <ul>
                            <li><a className="is-submenu has-new-feature is-2_2" href="/_components-forms-inputs.html">Inputs</a></li>
                            <li><a className="is-submenu" href="/_components-forms-controls.html">Controls</a></li>
                            <li><a className="is-submenu" href="/_components-forms-layouts.html">Form layouts</a></li>
                            <li><a className="is-submenu has-new-feature" href="/_components-forms-steps.html">Step forms</a></li>
                            <li><a className="is-submenu" href="/_components-forms-uploader.html">Uploader</a></li>
                        </ul>
                    </li>
                    <li className="has-children"><a className="parent-link" href="#"><span className="material-icons">adjust</span>Icons</a>
                        <ul>
                            <li><a className="is-submenu" href="/_components-icons-im.html">Icons Mind</a></li>
                            <li><a className="is-submenu" href="/_components-icons-sl.html">Simple Line Icons</a></li>
                            <li><a className="is-submenu" href="/_components-icons-fa.html">Font Awesome</a></li>
                            <li><a className="is-submenu" href="https://material.io/icons/" target="_blank">Material Icons</a></li>
                            <li><a className="is-submenu has-new-feature" href="/_components-extensions-iconpicker.html">Icon Picker</a></li>
                        </ul>
                    </li>
                </ul>
            </div>
            <div id="extras" className="navigation-menu-wrapper animated preFadeInRight fadeInRight is-hidden">
                <div className="navigation-menu-header">
                    <span>Extras</span>
                    <a className="ml-auto hamburger-btn navigation-close" href="javascript:void(0);">
                        <span className="menu-toggle">
                            <span className="icon-box-toggle">
                                <span className="rotate">
                                    <i className="icon-line-top"></i>
                                    <i className="icon-line-center"></i>
                                    <i className="icon-line-bottom"></i>
                                </span>
                            </span>
                        </span>
                    </a>
                </div>
                <ul className="navigation-menu">
                    <li className="has-children"><a className="parent-link" href="#"><span className="material-icons">dashboard</span>Dashboard
                            kit</a>
                        <ul>
                            <li><a className="is-submenu" href="/dashboard/">Main Layout</a></li>
                            <li><a className="is-submenu" href="/dashboard/dashboard-dark-nav.html">Dark Sidebar</a></li>
                            <li><a className="is-submenu" href="/dashboard/dashboard-blank.html">Blank page</a></li>
                            <li><a className="is-submenu" href="/dashboard/dashboard-widgets-data.html">Data widgets</a></li>
                            <li><a className="is-submenu" href="/dashboard/dashboard-widgets-social.html">Social widgets</a></li>
                            <li><a className="is-submenu" href="/dashboard/dashboard-feed.html">Dashboard feed</a></li>
                            <li><a className="is-submenu" href="/dashboard/dashboard-feed-post.html">Feed post</a></li>
                            <li><a className="is-submenu" href="/dashboard/dashboard-login.html">Login</a></li>
                        </ul>
                    </li>
                    <li className="has-children"><a className="parent-link" href="#"><span
                                className="material-icons">insert_chart</span>Charts</a>
                        <ul>
                            <li><a className="is-submenu" href="/dashboard/dashboard-chartjs.html">Chartjs charts</a></li>
                            <li><a className="is-submenu" href="/dashboard/dashboard-billboardjs.html">Billboardjs charts</a></li>
                            <li><a className="is-submenu" href="/dashboard/dashboard-peityjs.html">Peity charts</a></li>
                        </ul>
                    </li>
                    <li className="has-children"><a className="parent-link" href="#"><span
                                className="material-icons">assignment</span>Projects</a>
                        <ul>
                            <li><a className="is-submenu has-new-feature" href="/dashboard/dashboard-project-list.html">Projects</a>
                            </li>
                            <li><a className="is-submenu has-new-feature" href="/dashboard/dashboard-project-details.html">Project
                                    details</a></li>
                            <li><a className="is-submenu has-new-feature" href="/dashboard/dashboard-project-task.html">Project Task</a>
                            </li>
                            <li><a className="is-submenu has-new-feature" href="/dashboard/dashboard-project-mytasks.html">My Tasks</a>
                            </li>
                            <li><a className="is-submenu has-new-update" href="/dashboard/dashboard-events-board.html">Events Board</a>
                            </li>
                        </ul>
                    </li>
                    <li className="has-children"><a className="parent-link" href="#"><span
                                className="material-icons">grid_on</span>Datatable</a>
                        <ul>
                            <li><a className="is-submenu has-new-feature" href="/dashboard/dashboard-datatable-basic.html">Basic</a>
                            </li>
                            <li><a className="is-submenu has-new-feature"
                                    href="/dashboard/dashboard-datatable-variations.html">Variations</a></li>
                            <li><a className="is-submenu has-new-feature"
                                    href="/dashboard/dashboard-datatable-advanced.html">Advanced</a></li>
                        </ul>
                    </li>
                    <li className="has-children"><a className="parent-link" href="#"><span
                                className="material-icons">insert_drive_file</span>Documents</a>
                        <ul>
                            <li><a className="is-submenu has-new-update" href="/dashboard/dashboard-document-list.html">Documents
                                    List</a></li>
                            <li><a className="is-submenu has-new-update" href="/dashboard/dashboard-document-details.html">Document
                                    Details</a></li>
                            <li><a className="is-submenu has-new-update" href="/dashboard/dashboard-document-invoice.html">Invoice</a>
                            </li>
                        </ul>
                    </li>
                    <li className="has-children"><a className="parent-link" href="#"><span className="material-icons">people</span>Contacts</a>
                        <ul>
                            <li><a className="is-submenu has-new-update" href="/dashboard/dashboard-contacts-grid.html">Contacts
                                    Grid</a></li>
                            <li><a className="is-submenu has-new-update" href="/dashboard/dashboard-contacts-list.html">Contacts
                                    List</a></li>
                            <li><a className="is-submenu has-new-update" href="/dashboard/dashboard-contacts-single.html">Contact
                                    Details</a></li>
                        </ul>
                    </li>
                    <li className="has-children"><a className="parent-link has-new" href="#"><span className="material-icons">work</span>Crm</a>
                        <ul>
                            <li><a className="is-submenu has-new-update is-2_2" href="/dashboard/dashboard-crm-boards.html">Crm
                                    Projects</a></li>
                            <li><a className="is-submenu has-new-update is-2_2" href="/dashboard/dashboard-crm-kanban.html">Crm
                                    Kanban</a></li>
                            <li><a className="is-submenu has-new-update is-2_2" href="/dashboard/dashboard-crm-deal.html">Crm Deal</a>
                            </li>
                        </ul>
                    </li>
                    <li className="has-children"><a className="parent-link has-new" href="#"><span
                                className="material-icons">verified_user</span>Support
                            Desk</a>
                        <ul>
                            <li><a className="is-submenu has-new-update is-2_2" href="/dashboard/dashboard-support-dashboard.html">Desk
                                    Dashboard</a></li>
                            <li><a className="is-submenu has-new-update is-2_2" href="/dashboard/dashboard-support-tickets.html">Ticket
                                    List</a></li>
                            <li><a className="is-submenu has-new-update is-2_2" href="/dashboard/dashboard-support-ticket.html">Ticket
                                    Details</a></li>
                        </ul>
                    </li>
                    <li className="has-children"><a className="parent-link has-new" href="#"><span
                                className="material-icons">record_voice_over</span>Forum</a>
                        <ul>
                            <li><a className="is-submenu has-new-update is-2_2" href="/dashboard/dashboard-forum-home.html">Forum
                                    Home</a></li>
                            <li><a className="is-submenu has-new-update is-2_2" href="/dashboard/dashboard-forum-channel.html">Forum
                                    Channel</a></li>
                            <li><a className="is-submenu has-new-update is-2_2" href="/dashboard/dashboard-forum-topic.html">Forum
                                    Topic</a></li>
                        </ul>
                    </li>
                    <li className="has-children"><a className="parent-link has-new" href="#"><span
                                className="material-icons">apps</span>Apps</a>
                        <ul>
                            <li><a className="is-submenu has-new-update is-2_3" href="/dashboard/dashboard-chat-app.html">
                                    Chat UI</a></li>
                            <li><a className="is-submenu has-new-update is-2_3" href="/dashboard/dashboard-mailbox-inbox.html">
                                    Inbox UI</a></li>
                        </ul>
                    </li>
                </ul>
            </div>
        </div>
        <div id="backtotop"><a href="#"></a>
        </div>
    </>
  );
}

export default Layout;
